/**
 * Prévia da /empresas só no endereço de preview do Lovable (29/10/2026).
 *
 * Aceita apenas `id-preview--<id>.lovable.app` e `*.lovableproject.com`.
 * Nunca aceita materna360.com.br, o domínio publicado (`soft-glow-polish.lovable.app`)
 * nem qualquer outro. Não liga o B2B: formulário e resgate seguem dependendo
 * só de `B2B_PUBLICO_ATIVO`.
 */
export function ehPreviewLovable(hostname: string): boolean {
  const h = (hostname || "").toLowerCase();
  if (/^id-preview--[a-z0-9-]+\.lovable\.app$/.test(h)) return true;
  if (/^[a-z0-9-]+\.lovableproject\.com$/.test(h)) return true;
  return false;
}

/** Primeiro argumento: B2B_PAGINA_VISIVEL (só a página, nunca resgate/RH). */
export function podeVerEmpresas(paginaVisivel: boolean, nativo: boolean, hostname: string): boolean {
  if (nativo) return false;
  return paginaVisivel || ehPreviewLovable(hostname);
}

/** Destino de /empresas/demo e /empresas/*: a própria página quando ela abre. */
export function destinoSubrotaEmpresas(paginaVisivel: boolean, nativo: boolean, hostname: string): string {
  return podeVerEmpresas(paginaVisivel, nativo, hostname) ? "/empresas" : "/";
}

/** Rotas de resgate, aceite e RH: presas só a B2B_PUBLICO_ATIVO. */
export function rotasB2BAbertas(b2bAtivo: boolean, nativo: boolean): boolean {
  return b2bAtivo && !nativo;
}
